//
// Generated class PaymentInstallment
//

/// <reference path="PaymentInstallment_ManagedObject.ts" />

enum PaymentInstallmentStatus
{
    invalidAmount      = -1,
    
    fileGenerated      = 10,

    pending            = 100,
    locked             = 101,
    paid               = 102,
    returned           = 103,
    void               = 104,
    partialPayment     = 105,
    confirmedButNotPay = 106, // This mean the client say that the payment is done, but we have not received the money yet.
    doubtful           = 107,
    compensated        = 108,
    creditNote         = 109,
    review             = 110  // Held for manual review ( eg. payout reconcile mismatch ). Never payable.
}

class PaymentInstallment extends PaymentInstallment_ManagedObject
{
    get dateString() : string {
        return MIODateGetYearFromDate( this.date ) + "-" + MIODateGetMonthFromDate( this.date );
    }

    get monthString():string {
        if (this.date == null) return null;
        return MIODateGetStringForMonth( this.date.getMonth() );
    }

    /// "yyyy-mm-dd" of the due date: the installments list groups by it
    get dueDateString():string {
        if (this.dueDate == null) return null;
        return MIODateGetDateString( this.dueDate );
    }

    /// "yyyy-mm-dd" of the date: the list groups by it when sorting by date
    get dateDayString():string {
        if (this.date == null) return null;
        return MIODateGetDateString( this.date );
    }

    statusString(): string {
        return PaymentInstallment.statusStringFor( this.status );
    }

    static statusStringFor( status:number ): string {
        switch ( status ) {
            case -1: return MIOLocalizeString( "INVALID_AMOUNT", "INVALID AMOUNT" );
            case  10: return MIOLocalizeString( "FILE_GENERATED", "FILE GENERATED" );
            case  100: return MIOLocalizeString( "PENDING", "PENDING" );
            case  101: return MIOLocalizeString( "LOCKED", "LOCKED" );
            case  102: return MIOLocalizeString( "PAID", "PAID" );
            case  103: return MIOLocalizeString( "RETURNED", "RETURNED" );
            case  104: return MIOLocalizeString( "VOID", "VOID" );
            case  105: return MIOLocalizeString( "PARTIAL", "PARTIAL" );
            case  106: return MIOLocalizeString( "CONFIRMED", "CONFIRMED" );
            case  107: return MIOLocalizeString( "DOUBTFUL", "DOUBTFUL" );
            case  108: return MIOLocalizeString( "COMPENSATED", "COMPENSATED" );
            case  109: return MIOLocalizeString( "CREDIT_NOTE", "CREDIT NOTE" );
            case  110: return MIOLocalizeString( "REVIEW", "REVIEW" );
            default: return MIOLocalizeString( "UNKNOWN", "UNKNOWN" );
        }
    }
}
